/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ParameterCombinationTableDto } from './ParameterCombinationTableDto';
import {
    ParameterCombinationTableDtoFromJSON,
    ParameterCombinationTableDtoFromJSONTyped,
    ParameterCombinationTableDtoToJSON,
} from './ParameterCombinationTableDto';
import type { ExceptionData } from './ExceptionData';
import {
    ExceptionDataFromJSON,
    ExceptionDataFromJSONTyped,
    ExceptionDataToJSON,
} from './ExceptionData';
import type { I18nInfo } from './I18nInfo';
import {
    I18nInfoFromJSON,
    I18nInfoFromJSONTyped,
    I18nInfoToJSON,
} from './I18nInfo';
import type { Exception } from './Exception';
import {
    ExceptionFromJSON,
    ExceptionFromJSONTyped,
    ExceptionToJSON,
} from './Exception';

/**
 * 
 * @export
 * @interface Ptw100SetupCombinationsException
 */
export interface Ptw100SetupCombinationsException {
    /**
     * 
     * @type {string}
     * @memberof Ptw100SetupCombinationsException
     */
    readonly targetSite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100SetupCombinationsException
     */
    readonly message?: string | null;
    /**
     * 
     * @type {ExceptionData}
     * @memberof Ptw100SetupCombinationsException
     */
    data?: ExceptionData | null;
    /**
     * 
     * @type {Exception}
     * @memberof Ptw100SetupCombinationsException
     */
    innerException?: Exception;
    /**
     * 
     * @type {string}
     * @memberof Ptw100SetupCombinationsException
     */
    helpLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100SetupCombinationsException
     */
    source?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100SetupCombinationsException
     */
    hResult?: number;
    /**
     * 
     * @type {string}
     * @memberof Ptw100SetupCombinationsException
     */
    readonly stackTrace?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100SetupCombinationsException
     */
    code?: number;
    /**
     * 
     * @type {I18nInfo}
     * @memberof Ptw100SetupCombinationsException
     */
    i18n?: I18nInfo;
    /**
     * 
     * @type {ParameterCombinationTableDto}
     * @memberof Ptw100SetupCombinationsException
     */
    combinationTable?: ParameterCombinationTableDto;
    /**
     * 
     * @type {string}
     * @memberof Ptw100SetupCombinationsException
     */
    $type?: Ptw100SetupCombinationsExceptionTypeEnum;
}


/**
 * @export
 */
export const Ptw100SetupCombinationsExceptionTypeEnum = {
    PtwPtw100AppZeroApplicationSharedExceptionsPtw100SetupCombinationsExceptionPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Exceptions.Ptw100SetupCombinationsException, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type Ptw100SetupCombinationsExceptionTypeEnum = typeof Ptw100SetupCombinationsExceptionTypeEnum[keyof typeof Ptw100SetupCombinationsExceptionTypeEnum];



/**
 * Check if a given object implements the Ptw100SetupCombinationsException interface.
 */
export function instanceOfPtw100SetupCombinationsException(value?: unknown): value is Ptw100SetupCombinationsException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(Ptw100SetupCombinationsExceptionTypeEnum)[0];
}

export function Ptw100SetupCombinationsExceptionFromJSON(json: any): Ptw100SetupCombinationsException {
    return Ptw100SetupCombinationsExceptionFromJSONTyped(json, false);
}

export function Ptw100SetupCombinationsExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ptw100SetupCombinationsException {
    if (json == null) {
        return json;
    }
    return {
        
        'targetSite': json['targetSite'] == null ? undefined : json['targetSite'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ExceptionDataFromJSON(json['data']),
        'innerException': json['innerException'] == null ? undefined : ExceptionFromJSON(json['innerException']),
        'helpLink': json['helpLink'] == null ? undefined : json['helpLink'],
        'source': json['source'] == null ? undefined : json['source'],
        'hResult': json['hResult'] == null ? undefined : json['hResult'],
        'stackTrace': json['stackTrace'] == null ? undefined : json['stackTrace'],
        'code': json['code'] == null ? undefined : json['code'],
        'i18n': json['i18n'] == null ? undefined : I18nInfoFromJSON(json['i18n']),
        'combinationTable': json['combinationTable'] == null ? undefined : ParameterCombinationTableDtoFromJSON(json['combinationTable']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function Ptw100SetupCombinationsExceptionToJSON(value?: Omit<Ptw100SetupCombinationsException, 'targetSite'|'message'|'stackTrace'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'data': ExceptionDataToJSON(value['data']),
        'innerException': ExceptionToJSON(value['innerException']),
        'helpLink': value['helpLink'],
        'source': value['source'],
        'hResult': value['hResult'],
        'code': value['code'],
        'i18n': I18nInfoToJSON(value['i18n']),
        'combinationTable': ParameterCombinationTableDtoToJSON(value['combinationTable']),
        '$type': value['$type'],
    });
}

